import { omitInviteQueryParams } from '@/modules/auth/utils/inviteToken'

const UNSAFE_REDIRECT_PREFIXES = ['/404', '/403', '/login', '/register']

export function isUnsafeRedirectPath(path: string | null | undefined): boolean {
  if (!path) {
    return true
  }

  const [pathname] = path.split('?')
  if (UNSAFE_REDIRECT_PREFIXES.some(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`))) {
    return true
  }

  return path.includes('inviteToken')
}

export function sanitizeRedirectPath(path: string | null | undefined): string | null {
  if (isUnsafeRedirectPath(path)) {
    return null
  }
  return path ?? null
}

/**
 * Splits a stored redirect target into a router `{ path, query }`, dropping invite params.
 *
 * Query precedence is `carriedQuery` < the target's own querystring < `additionalQuery`:
 * `carriedQuery` is for params that must survive a flow (the register funnel forwards
 * `createSpaceFromTemplateId`, which the dashboard consumes) without overriding a param the
 * redirect target itself specified.
 */
export function parseNavigationTarget(
  location: string,
  additionalQuery: Record<string, unknown> = {},
  carriedQuery: Record<string, unknown> = {}
): { path: string; query: Record<string, string> } {
  const [pathname, search = ''] = location.split('?')
  const queryFromLocation = Object.fromEntries(new URLSearchParams(search))

  return {
    path: pathname || '/recently-viewed',
    query: omitInviteQueryParams({ ...carriedQuery, ...queryFromLocation, ...additionalQuery })
  }
}
